/**
 * We need to keep alignment with https://github.corp.ebay.com/Stubhub-npm/brand/blob/master/styles/_breakpoints.scss
 * for below mediaQuery breakpoints
 */

export default {
  small: '(max-width: 639px)',
  medium: '(min-width: 640px) and (max-width: 949px)',
  large: '(min-width: 950px) and (max-width: 1280px)',
  extraLarge: '(min-width:1281px)',
};
